export const USER_TYPES = {
    SUPER_ADMIN: 1,
    SUPERVISOR: 2,
    AGENT: 3,
    CUSTOMER: 4,
}

// Status options for general / sales enquiries. API values are new | contacted
// | closed; the labels below are what we surface to the user.
export const INQUIRY_STATUS_OPTIONS = [
    { value: 'new', label: 'Pending' },
    { value: 'contacted', label: 'In Progress' },
    { value: 'closed', label: 'Addressed' },
];

export const TICKET_TYPE_OPTIONS = [
    { value: 'sales', label: 'Sales', },
    { value: 'query', label: 'Query', },
    { value: 'ticket', label: 'Ticket', },
]

export const USER_STATUSES = {
    ACTIVE: "ACTIVE",
    IN_ACTIVE: "IN_ACTIVE",
    SUSPENDED: "SUSPENDED",
}

export const GENDERS = {
    MALE: "MALE",
    FEMALE: "FEMALE",
    OTHERS: "OTHERS",
}

export const TICKET_PRIORITY_OPTIONS = [
    { value: 'low', label: 'Low', },
    { value: 'medium', label: 'Medium', },
    { value: 'high', label: 'High', },
    { value: 'urgent', label: 'Urgent', },
];

export const ALL_TICKET_STATUS = [
    { value: 'open', label: "Open", },
    { value: 'in_progress', label: "In Progress", },
    // { value: 'escalated', label: "Escalated", disabled: true },
    // { value: 're_open', label: "Re Opened", disabled: true },
    { value: 'on_hold', label: "On Hold", },
    { value: 'resolved', label: "Resolved", },
    { value: 'closed', label: "Closed", },
];

export const ALL_TICKET_INTERNAL_STATUS = [
    { value: 're_assigned', label: "Re Assign", },
    { value: 'solved', label: "Solved", },
    // { value: 'in_progress', label: "In Progress", },
    // { value: 'closed', label: "Closed", },
    // { value: 'escalated', label: "Escalated", },
];
